import React from "react";

function priorityColor(priority){

if(priority==="HIGH")
return "bg-red-100 text-red-700";

if(priority==="MEDIUM")
return "bg-amber-100 text-amber-700";

return "bg-green-100 text-green-700";

}

function normalize(item){

if(!item){

return{
text:"Experiment missing",
priority:"MEDIUM",
effort:"MEDIUM",
impact:"MEDIUM"
};

}

if(typeof item==="string"){

return{

text:item,
priority:"MEDIUM",
effort:"MEDIUM",
impact:"MEDIUM"

};

}

return{

text:item.text || "Experiment",
priority:item.priority || "MEDIUM",
effort:item.effort || "MEDIUM",
impact:item.impact || "MEDIUM"

};

}

export default function ExperimentsBoard({data}){

const experiments=(data?.experiments || [])
.filter(Boolean)
.map(normalize);

if(experiments.length === 0){

return(

<div className="bg-white border rounded-xl p-6 shadow-sm">

<h3 className="text-lg font-semibold text-blue-900">
Growth Experiments
</h3>

<p className="text-sm text-slate-500 mt-3">
No experiments identified yet.
</p>

</div>

);

}

return(

<div className="bg-white border rounded-xl p-6 shadow-sm">

<h3 className="text-lg font-semibold text-blue-900">
Growth Experiments
</h3>

<p className="text-sm text-slate-600 mt-1">
AI suggested validation experiments.
</p>

<div className="grid grid-cols-1 gap-3 mt-4">

{experiments.map((item,i)=>(

<div
key={i}
className="bg-amber-50 border border-amber-200 rounded-lg p-4"
>

<div className="flex gap-3">

<div className="w-7 h-7 bg-amber-500 text-white rounded flex items-center justify-center text-xs font-semibold">

{i+1}

</div>

<div>

<p className="text-sm text-slate-700">
{item.text}
</p>

<div className="flex gap-2 mt-2 flex-wrap">

<span className={`text-xs px-2 py-1 rounded ${priorityColor(item.priority)}`}>
{item.priority}
</span>

<span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
Effort {item.effort}
</span>

<span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded">
Impact {item.impact}
</span>

</div>

</div>

</div>

</div>

))}

</div>

</div>

);

}